import React from "react";
import "./About.css";

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>About Merabuddy</h2>
            <p>
              MERABUDDY is this Generation & State of the Art reminder apps,
              First time in INDIA & May be First Time in World, Specially
              Designed for People who WANT to stay organised without stress. In
              this Fast World Many People forgets his Important Tasks like Child
              care related matter, Child Education related matter, Health,
              Hospital, Medicine related Matter, Parents care Related Matter,
              business Meetings, Travel Schedule, good events, bad events & many
              more. When event time gone, People regret or Feels Guilty himself.
              Some People can appoint Personal Secretary, but many People can
              not Afford to appoint Personal Secretary. To Solve all These
              Issues, We made this apps. Our AI learns your habits, understands
              your priority, Gives You reminder, Call, Email, SMS before the
              event, With Support of MERABUDDY you can get reminder before
              events & you can build better routine, Hence You can regenerate
              Yourself for batter Health, Wealth & Happiness.
            </p>

            <div className="stats">
              <div className="stat">
                <h3>50K+</h3>
                <p>Active Users</p>
              </div>
              <div className="stat">
                <h3>2M+</h3>
                <p>Reminders Set</p>
              </div>
              <div className="stat">
                <h3>95%</h3>
                <p>Task Completion</p>
              </div>
            </div>
          </div>

          <div className="about-visual">
            <div className="visual-card">
              <div className="card-content">
                <h4>Reminder Intelligence</h4>
                <div className="progress-bars">
                  <div className="progress-item">
                    <span>Task Recognition</span>
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{ width: "96%" }}
                      ></div>
                    </div>
                  </div>
                  <div className="progress-item">
                    <span>Smart Timing</span>
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{ width: "94%" }}
                      ></div>
                    </div>
                  </div>
                  <div className="progress-item">
                    <span>User Satisfaction</span>
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{ width: "98%" }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
